import config from 'config';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { client } from './client';
import { fakeClient } from './fakeClient';

export const getClient = (type = config.api.apiType): ApolloClient<NormalizedCacheObject> => {
  return type === 'release' ? client : fakeClient;
};
